import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { ACCREDITED_ESTABLISHMENTS_PLANS_FILTER } from '@/global/constants/reactQueryKeys'
import {
  GetFilterResponse,
  getPlansFilterOptions
} from '@/modules/accredited-establishments/api'
import { addError } from '@/global/plugins/observability'
import {
  AccreditedEstablishmentsCode,
  Context
} from '@/global/plugins/observability/observability.constants'
import { makeItems } from './useGetPlansFilter.helpers'
import { AxiosError } from 'axios'
import { toastApiError } from '@/global/utils/toastApiError/toastApiError'
import { ApiErrorResponse } from '@/global/api/types'

export const useGetPlansFilter = () => {
  const result = useQuery<GetFilterResponse, AxiosError<ApiErrorResponse>>({
    queryKey: ACCREDITED_ESTABLISHMENTS_PLANS_FILTER,
    queryFn: getPlansFilterOptions,
    select: data => makeItems(data)
  })

  const { error } = result

  useEffect(() => {
    if (error) {
      const data = {
        context: Context.ACCREDITED_ESTABLISHMENTS,
        code: AccreditedEstablishmentsCode.GET_PLANS_FILTER_OPTIONS_ERROR,
        message: 'Erro ao obter os planos'
      }
      addError({ error, data })

      toastApiError({ status: error.response?.status })
    }
  }, [error])

  return result
}
